module.exports = __webpack_public_path__ + "static/media/PROF.b2bbc80d.JPG";